import { Map } from 'immutable';

import {
  FETCH_USER_SUCCESS,
} from './actions';
import User from './model';

export default function users(state = new Map(), action) {
  switch (action.type) {
    case FETCH_USER_SUCCESS: {
      const user = new User(action.payload);
      return state.set(`${user.id}`, user);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./data/Users/reducer.js